<div class="topbar">
  <div class="month-nav">
    <button class="step" (click)="prevMonth()" [disabled]="!canGoBack" aria-label="Previous month">‹</button>
    <!-- monthLabel returns '' (empty string) when there is no month, so || is required here; ?? would render blank. -->
    <span class="month">{{ monthLabel || 'No data' }}</span>
    <button class="step" (click)="nextMonth()" [disabled]="!canGoForward" aria-label="Next month">›</button>
  </div>
  <span class="meta" *ngIf="!loading">
    {{ kpis.txnCount }} transactions
    <span class="review" *ngIf="uncategorizedCount">· {{ uncategorizedCount }} uncategorized</span>
  </span>
</div>

<p class="loading" *ngIf="loading">Loading…</p>
<p class="error" *ngIf="error">{{ error }}</p>

<ng-container *ngIf="!loading">
  <div class="kpis">
    <div class="card kpi">
      <span class="lbl">Spent</span>
      <b class="num">{{ fmt(kpis.spentCents) }}</b>
      <span class="sub" [class.up]="(kpis.deltaPct ?? 0) > 0">{{ deltaLabel }}</span>
    </div>
    <div class="card kpi">
      <span class="lbl">Income</span>
      <b class="num">{{ fmt(kpis.incomeCents) }}</b>
      <span class="sub">this month</span>
    </div>
    <div class="card kpi">
      <span class="lbl">Net</span>
      <b class="num" [class.positive]="kpis.netCents >= 0">{{ fmt(kpis.netCents) }}</b>
      <span class="sub">income less spending</span>
    </div>
    <div class="card kpi">
      <span class="lbl">Fixed / mo</span>
      <b class="num">{{ fmt(nutCents) }}</b>
      <span class="sub">as of today</span>
    </div>
  </div>

  <div class="grid2">
    <div class="card panel mix-panel">
      <div class="lbl">
        <span *ngIf="!drilledGroupId">Spending mix · by group</span>
        <span *ngIf="drilledGroupId">Spending mix · {{ mixCenterLabel }}</span>
        <button class="link-btn back-btn" *ngIf="drilledGroupId" (click)="backToGroups()">
          ← All groups
        </button>
      </div>
      <div class="mix" *ngIf="displayedMix.length; else noMix">
        <mm-donut class="donut-slot"
                  [segments]="displayedMix"
                  [centerValue]="mixCenterValue"
                  [centerLabel]="mixCenterLabel"
                  [ariaLabel]="drilledGroupId ? mixCenterLabel + ' spending by category'
                                              : 'Spending by group'"
                  (select)="onMixSelect($event)"></mm-donut>
        <ul class="legend">
          <li *ngFor="let s of displayedMix; trackBy: trackSegment"
              (click)="onMixSelect(s.id)">
            <span class="sw" [style.background]="s.color"></span>
            <span class="name">{{ s.label }}</span>
            <span class="amt num">{{ fmt(s.value) }}</span>
          </li>
        </ul>
      </div>
      <ng-template #noMix><p class="empty">No spending this month.</p></ng-template>
    </div>

    <div class="card panel">
      <div class="lbl">Spending · last 6 months</div>
      <mm-bars [data]="trend"
               [displayValues]="trendDisplay"
               [averageValue]="trendAverage"
               [averageLabel]="averageLabel"
               [highlightIndex]="trendHighlightIndex"
               ariaLabel="Spending by month, last six months"
               (select)="onSelectTrendMonth($event)"></mm-bars>
    </div>

    <div class="card panel">
      <div class="lbl">Budgets</div>
      <p class="empty" *ngIf="!budgets.length">
        No budgets set. <a routerLink="../budgets">Set one</a>.
      </p>
      <div class="brow" *ngFor="let b of budgets; trackBy: trackBudget">
        <span class="bname">{{ b.categoryName }}</span>
        <span class="track"><span class="fill" [class.over]="b.isOver"
              [style.width.%]="b.pctUsed"></span></span>
        <span class="bnums" [class.over]="b.isOver">
          {{ fmt(b.spentCents) }} / {{ fmt(b.limitCents) }}
        </span>
      </div>
    </div>

    <div class="card panel">
      <div class="lbl">Recurring · {{ fmt(nutCents) }} / mo · as of today</div>
      <p class="empty" *ngIf="!recurring.length">Nothing detected yet.</p>
      <div class="rrow" *ngFor="let s of recurring; trackBy: trackRecurring">
        <span class="rname">{{ s.merchant }}</span>
        <span class="rnext">{{ s.nextExpected + 'T00:00:00' | date:'MMM d' }}</span>
        <span class="ramt">{{ fmt(s.medianCents) }}</span>
      </div>
    </div>
  </div>
</ng-container>
